export const ALL_MEMBERS_ROUTE = '/conversations/all-members';
export const ALL_MEMBERS_KEY = 'all-members';
export const MESSAGE_RECEIPTS_PAGE_SIZE = 50;
export const MEMBERS_PAGE_SIZE = 100;
